export const getDefaultValues = (feedItemDetails, selectedLinkType) => ({
  Subject: feedItemDetails?.FeedItemSubject || '',
  SubjectSpecial: feedItemDetails?.FeedItemSubjectSpecial || '',
  Link: feedItemDetails?.FeedItemLink || '',
  LinkTitle: selectedLinkType || '',
  FeedItemCssCaptionID: feedItemDetails?.FeedItemCssCaptionID || '',
  ImageSrc: feedItemDetails?.FeedItemImageSrc || '',
  TotalViewOnStart: feedItemDetails?.FeedItemTotalViewOnStart || '',
  TotalClickOnStart: feedItemDetails?.FeedItemTotalClickOnStart || '',
  ContentDate: feedItemDetails?.FeedItemContentDate || '',
  IsActive: !!feedItemDetails?.FeedItemIsActive || false,
  OrderIndex: feedItemDetails?.FeedItemOrderIndex || '',
  FeedItemCostAmount: feedItemDetails?.FeedItemCostAmount || '',
  FeedItemCostLable: feedItemDetails?.FeedItemCostLable || '',
  FeedItemContentID: feedItemDetails?.FeedItemContentID || '',
  FeedItemContentType: feedItemDetails?.FeedItemContentType || 0,
  TrasnsactionAmountTypeID: feedItemDetails?.TrasnsactionAmountTypeID || '',
});
